import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { AIChat } from "@/components/AIChat";

export default function AIAssistant({ open, onOpenChange, onTasksChanged }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900/95 backdrop-blur-md border-red-900/30 text-gray-200 max-w-2xl p-0 gap-0 h-[88vh] sm:h-[80vh] flex flex-col overflow-hidden">
        <DialogTitle className="sr-only">AI Meeting Assistant</DialogTitle>
        <DialogDescription className="sr-only">
          Chat with the AI teammate, record a voice note, or upload audio to create notes and tasks.
        </DialogDescription>
        <AIChat active={open} onTasksChanged={onTasksChanged} className="flex-1" />
      </DialogContent>
    </Dialog>
  );
}
